import React, { useState } from "react";
import {
  FiEye,
  FiEdit2,
  FiSearch,
  FiFilter,
  FiUser,
  FiMail,
  FiCalendar,
  FiCheckCircle,
  FiXCircle,
  FiBookOpen,
  FiStar,
  FiClock,
  FiToggleLeft,
  FiToggleRight,
  FiUsers,
  FiTrendingUp,
  FiTrendingDown,
  FiArrowUp,
  FiArrowDown,
  FiRefreshCw,
  FiTrash2,
  FiHash,
  FiTag,
  FiInfo,
  FiAlertCircle,
  FiAward,
  FiBarChart2,
} from "react-icons/fi";
import {
  MdOutlineSearch,
  MdOutlineFilter,
  MdOutlinePerson,
  MdOutlineEmail,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineBook,
  MdOutlineStar,
  MdOutlineAccessTime,
  MdOutlineEdit,
  MdOutlineDelete,
  MdOutlineVisibility,
  MdOutlineRefresh,
  MdOutlineInfo,
  MdOutlineAward,
  MdOutlineBarChart,
} from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { LiaEdit } from "react-icons/lia";
import { CiFilter, CiSearch } from "react-icons/ci";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { GoBlocked } from "react-icons/go";
import SortableHeader from "../../../components/SortableHeader";

const ExpertMangmentTable = ({
  handleUserBlock,
  TableName,
  TableHeader,
  TableData,
  handleExpertAction,
  handleFilter,
  handlePageClick,
  total,
  pageNo,
  size,
  offset,
  setExpertkeyword,
  expertKeyword,
  currentSortKey,
  currentSortOrder,
  onSort,
}) => {
  const [imgError, setImgError] = useState(false);

  // Normalize headers: supports both string[] and {label, sortKey}[]
  const normalizedHeaders =
    TableHeader?.map((h) =>
      typeof h === "string" ? { label: h, sortKey: null } : h
    ) || [];

  // Status badge component
  const StatusBadge = ({ isDisable }) => {
    if (!isDisable) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
          <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
          Active
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full">
        <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
        Disabled
      </span>
    );
  };

  // Rating display component
  const RatingDisplay = ({ rating }) => {
    const stars = Math.round(rating || 0);
    return (
      <div className="flex items-center gap-1">
        <div className="flex items-center">
          {[...Array(5)].map((_, i) => (
            <FiStar
              key={i}
              className={`w-3.5 h-3.5 ${
                i < stars ? "text-yellow-400 fill-current" : "text-gray-300"
              }`}
            />
          ))}
        </div>
        <span className="text-sm font-medium text-gray-700 ml-1">
          {rating?.toFixed(1) || "0.0"}
        </span>
      </div>
    );
  };

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
              <FiUsers className="w-4 h-4 text-[#715EFE]" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-800">
                {TableName}
              </h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                {TableData?.length || 0} experts
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            {/* Search */}
            <div className="relative flex-1 sm:min-w-[180px]">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search experts..."
                className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                onChange={(e) => setExpertkeyword(e.target.value)}
                value={expertKeyword}
              />
            </div>

            {/* Filter */}
            <div className="relative min-w-[120px]">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FiFilter className="text-gray-400 w-4 h-4" />
              </div>
              <select
                className="appearance-none w-full h-10 pl-9 pr-8 py-2 bg-white border border-gray-200 text-sm text-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                onClick={handleFilter}
                onChange={handleFilter}
              >
                <option value={""}>All Status</option>
                <option value={"enable"}>Active</option>
                <option value={"disable"}>Disabled</option>
              </select>
              <FiClock className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                {normalizedHeaders.map((heading, index) => {
                  const headerIcons = {
                    "#": null,
                    "Expert Name": FiUser,
                    "Courses Created": FiBookOpen,
                    "Rating (Avg)": FiStar,
                    Status: FiCheckCircle,
                    "Join Date": FiCalendar,
                    Action: null,
                  };
                  const Icon = headerIcons[heading.label] ?? null;
                  return (
                    <th
                      key={index}
                      scope="col"
                      className="px-3 md:px-4 py-3 whitespace-nowrap"
                    >
                      <SortableHeader
                        label={heading.label}
                        sortKey={heading.sortKey}
                        currentSortKey={currentSortKey}
                        currentSortOrder={currentSortOrder}
                        onSort={onSort}
                        icon={Icon}
                      />
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {TableData && TableData.length > 0 ? (
                TableData.map((learner, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50/70 transition-colors duration-150 group"
                  >
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-medium text-gray-400">
                        {offset + index + 1}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-3">
                        {!imgError && learner?.profileImage ? (
                          <img
                            src={learner.profileImage}
                            alt="Avatar"
                            className="w-9 h-9 rounded-full object-cover border-2 border-gray-200"
                            onError={() => setImgError(true)}
                          />
                        ) : (
                          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center border-2 border-gray-200">
                            <FiUser className="text-[#715EFE] text-sm" />
                          </div>
                        )}
                        <div className="min-w-0">
                          <p
                            className="text-sm font-semibold text-gray-800 truncate max-w-[120px] md:max-w-[180px] capitalize"
                            title={learner?.fullName}
                          >
                            {learner?.fullName?.replace(/_/g, " ") || "Unknown"}
                          </p>
                          {learner?.isDeleted && (
                            <span className="text-[10px] font-medium text-rose-500">
                              Account Deleted
                            </span>
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1.5">
                        <FiBookOpen className="w-3.5 h-3.5 text-[#715EFE]" />
                        <span className="text-sm font-medium text-gray-700">
                          {learner.totalCourse || 0}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <RatingDisplay rating={learner?.rating} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <StatusBadge isDisable={learner?.isDisable} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-700 whitespace-nowrap">
                          {learner?.createdAt
                            ? moment(learner.createdAt).format("MMM D, YYYY")
                            : "N/A"}
                        </span>
                        {learner?.createdAt && (
                          <span className="text-xs text-gray-400">
                            {moment(learner.createdAt).format("h:mm A")}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1">
                        <button
                          title={learner.isDisable ? "Activate" : "Disable"}
                          className={`p-1.5 rounded-lg transition-all duration-200 ${
                            learner.isDisable
                              ? "text-emerald-400 hover:text-emerald-600 hover:bg-emerald-50"
                              : "text-amber-400 hover:text-amber-600 hover:bg-amber-50"
                          }`}
                          onClick={() => handleUserBlock(learner)}
                        >
                          {learner.isDisable ? (
                            <FiToggleRight className="w-4 h-4" />
                          ) : (
                            <FiToggleLeft className="w-4 h-4" />
                          )}
                        </button>
                        <button
                          title="View"
                          className="p-1.5 text-blue-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200"
                          onClick={() => handleExpertAction("VIEW", learner)}
                        >
                          <FiEye className="w-4 h-4" />
                        </button>
                        <button
                          title="Edit"
                          className="p-1.5 text-[#715EFE] hover:text-[#855DF6] hover:bg-[#715EFE]/10 rounded-lg transition-all duration-200"
                          onClick={() => handleExpertAction("EDIT", learner)}
                        >
                          <FiEdit2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={normalizedHeaders.length}
                    className="px-4 py-12 text-center"
                  >
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-gray-50 rounded-full">
                        <FiUsers className="w-10 h-10 text-gray-300" />
                      </div>
                      <p className="text-sm font-medium text-gray-500">
                        No experts found
                      </p>
                      <p className="text-xs text-gray-400">
                        Try adjusting your search or filters
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {total > 5 && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-100 bg-gray-50/50">
            <div className="text-sm text-gray-500">
              Showing {offset + 1} to {Math.min(offset + size, total)} of {total}{" "}
              entries
            </div>
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"px-2 text-gray-400"}
              pageCount={Math.ceil(total / size)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"flex items-center gap-1"}
              pageClassName={"px-2"}
              pageLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              previousClassName={"px-2"}
              previousLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              nextClassName={"px-2"}
              nextLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              activeClassName={"bg-[#715EFE] text-white rounded-md"}
              activeLinkClassName={
                "bg-[#715EFE] text-white px-3 py-1 rounded-md"
              }
              disabledClassName={"opacity-50 cursor-not-allowed"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpertMangmentTable;